var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var WarningIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M12.639 4.17a1.3 1.3 0 0 1 .477.477l7.782 13.593a1.286 1.286 0 0 1-1.116 1.925H4.218a1.286 1.286 0 0 1-1.116-1.925l7.782-13.593a1.286 1.286 0 0 1 1.755-.477Zm-.666 11.922c-.329 0-.606.114-.833.344-.227.23-.34.509-.34.836 0 .375.119.667.356.876.237.209.514.313.832.313.313 0 .587-.106.821-.317.235-.211.352-.502.352-.872 0-.327-.116-.606-.348-.836a1.15 1.15 0 0 0-.84-.344ZM11.988 8c-.37 0-.582.113-.809.339-.227.225-.34.54-.34.943 0 .197.107 1.637.32 4.32.048.452.126.788.235 1.01.11.22.305.33.586.33.277 0 .475-.113.595-.342.12-.228.198-.556.234-.983.26-2.41.391-3.721.391-3.935 0-.544-.076-.96-.227-1.249-.15-.289-.537-.433-.985-.433Z", fill: "currentColor", "fill-rule": "evenodd", "fill-opacity": ".86" }))); };
export default WarningIcon;
